export default "__VITE_ASSET__UZDH3_dU__"